import Backbone from 'backbone';
import './vendors/backbone-cocktail';
import App from './site/app';

// Overwrite Backbone jQuery instance so it includes plugins
Backbone.$ = $;

App.start();
